export default __webpack_public_path__ + "static/colors-3dcc7418601e1095588d651ccbb4e366.png";